import { render, staticRenderFns } from "./ResumenCobros.vue?vue&type=template&id=526c934a&"
import script from "./ResumenCobros.vue?vue&type=script&lang=js&"
export * from "./ResumenCobros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports